// Mirrors the palette declared in styles/globals.css.
// The Python build assigns each employer a colorIndex via a hash of name;
// here we resolve that index to a CSS custom property reference.

export function employerColorVar(colorIndex: number): string {
  return `var(--color-employer-${colorIndex % 12})`;
}
